import {Component, OnDestroy, OnInit, Inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {Subject} from 'rxjs';
import { ErrorDetailModalData } from './error-detail-modal.data';

@Component({
    selector: 'app-error-detail-modal',
    templateUrl: './error-detail-modal.component.html',
    styleUrls: ['./error-detail-modal.component.css'],
    standalone: false
})
export class ErrorDetailModalComponent implements OnInit, OnDestroy {
    acceptClose: Subject<boolean> = new Subject();

    constructor(public dialogRef: MatDialogRef<ErrorDetailModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ErrorDetailModalData) {}

    ngOnInit() {
    }

    ngOnDestroy() {
        this.acceptClose.next(true);
    }

    close() {
        this.dialogRef.close();
    }

}
